import { render, staticRenderFns } from "./new-circle.component.vue?vue&type=template&id=a486b818&scoped=true&"
import script from "./new-circle.component.vue?vue&type=script&lang=ts&"
export * from "./new-circle.component.vue?vue&type=script&lang=ts&"
import style0 from "./new-circle.component.vue?vue&type=style&index=0&id=a486b818&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a486b818",
  null
  
)

export default component.exports